import Serializable from './serializable';

export class GameTemplate extends Serializable {
	id: string;

	themeId: string;
	episodeId: string;

	name: {} = {};
	description: {} = {};
	minimumNativeVersion: string;

	title: {} = {};
	articleText: {} = {};
	highlightPicture: string;
	highlightText: {} = {};

	availableLanguages: [];
	workingLanguages: [];
	defaultLang: string;

	ttsVoiceId:string;
	languageTtsVoiceId: {} = {};

	locationMode: string; //GEO/VIRTUAL/NONE
	mapTheme: {
		virtualMapUrl: string; //https://coddy-app.firebaseapp.com/assets/map/pirates
		minZoom: number;
		maxZoom: number;
	}

	alwaysVisible: boolean;
	
	timeLimited: boolean;
	timeLimitedMinutes: number;
	timerStartMission: string;
	timerStopMission: string;
	stopWhenOver: boolean;
	timerFallbackMission: string;

	isProgressActive: boolean;
	progressAverageSteps: number;

	startTime: number;
	duration: number;
	endTime: number;
	timezone: string;

	hasRoles: boolean;
	hasCharacters: boolean;
	hasObjects: boolean = true;
	hasResources: boolean;
	hasBuildings: boolean;
	creationDate: number;

	pictureUrl: string;
	thumbFileName: string;
	thumbFileURL: string;
	pictureLastUpdate: number;

	documents: {} = {en:{}, fr:{}, nl:{}};
	instructions: {} = {en:"", fr:"", nl:""};
	hasGameOverUrl: boolean;
	gameOverUrl: string;

	averageMissionCount: number;
	missions;

	getTtsVoiceId(lang){
		if(this.languageTtsVoiceId && this.languageTtsVoiceId[lang]){
			return this.languageTtsVoiceId[lang];
		}
		return this.ttsVoiceId;
	}
}
